module.exports = __webpack_public_path__ + "assets/img/btn-view-pedigree-chart-66d435d5.png";